<template>
    <OmniButton @click="refreshCache" class="regenerate-trigger-cache" :disabled="isProcessing || disabled">
        <span class="icon"><font-awesome-icon icon="sync-alt" :spin="isProcessing"/></span>
        <span class="label">Systeeminstellingen cache vernieuwen</span>
    </OmniButton>
</template>

<style lang="scss">
.omni-btn.regenerate-trigger-cache {
    padding: .5rem 1rem;
}

.regenerate-trigger-cache {
    .icon {
        margin-right: .5rem;
    }
}

.loader {
    font-size: 12px;
    line-height: 18px;
}
</style>

<script>
export default {
    name: "RefreshSystemSettingsCacheButton",

    props: {
        disabled: {default: false },
    },

    data() {
        return {
            isProcessing: false,
        };
    },

    methods: {
        refreshCache() {
            this.isProcessing = true;
            this.$http
                .post("/api/rest/refresh-system-settings-cache", {})
                .then((response) => {
                    this.$alert("De systeeminstellingen cache is vernieuwd")
                })
                .catch((error, response) => {
                    this.$alert("Fout bij het vernieuwen van de cache", "error");
                    console.error(`refreshCache: ${error}`);
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        },
    },
};
</script>
